<template>
  <div
    class="confirmation"
    :class="{
      active: opened == true,
      'confirmation--centered': centered == true
    }"
  >
    <div class="confirmation__overlay" />
    <div class="confirmation__box">
      <div class="confirmation__box__text text-left">
        <h4>{{ $t("necoSeNepovedlo") }}</h4>

        <div>
          <p>
            {{
              $t("kontaktujteSvehoObchodnihoZastupceAPozadejteOZmenuSmlouvy")
            }}
          </p>
        </div>
      </div>
      <div
        class="confirmation__box__buttons d-flex align-items-center justify-content-end"
      >
        <button class="btn btn-primary" @click="close()">
          {{ $t("ok") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
//import _ from "lodash";
//import axios from "axios";
export default {
  props: {
    opened: Boolean,
    items: Array,
    centered: Boolean
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
